import React from 'react';
import classNames from 'classnames';
import { FavoritesIcon, FilledFavoritesIcon } from "@kursk/components/ui/icons";
import styles from './FavoritesButton.module.scss';

type TProps = {
  isFavorite: boolean;
  isLoading: boolean;
  onClick: () => void;
  withoutBorder?: boolean;
}

export const FavoritesButton = ({
  isFavorite,
  isLoading,
  onClick,
  withoutBorder,
}: TProps) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    onClick();
  }

  return (
    <>
      <button
        className={classNames(styles.favoriteButton, withoutBorder && styles.withoutBorder)}
        onClick={handleClick} disabled={isLoading}
      >
        {isFavorite ?
          <FilledFavoritesIcon className={styles.default}/> :
          <FavoritesIcon className={styles.filled}/>
        }
      </button>
    </>
  );
};
